<template>
	<div class="dropdown">
		<h1 v-if="!edit">{{activeObject}}</h1>
		<h1 v-else>Edit <i>{{activeObject}}</i></h1>
		<div class="popup">
			<ul class="links">
				<li v-for="object in content" v-bind:key="object.id">
					<router-link v-if="object.translations" :to="`/${mainslug}/${object.id}`"><span v-on:click="clickHandler" :data-id="`${object.id}`">{{object.translations[Object.keys(object.translations)[0]].value}}</span></router-link>
					<router-link v-if="user.roles['Admin']" class="btn-edit" :to="`/${mainslug}/edit/${object.id}`"><i class="fa fa-pen"></i></router-link>
				</li>

				<li v-if="mainslug === 'settings'">
					<router-link to="/settings"><span v-on:click="clickHandler">General Settings</span></router-link>
				</li>
				<li v-if="user.roles['Admin']">
					<router-link class="btn btn-add-object" :to="`/${mainslug}/add/object`">Add object</router-link>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>

import cms from '../modules/cms.js'

export default {
	name: 'DropDown',
	props: {
		title: String,
		mainslug: String,
		content: Array,
		edit: Boolean
	},
	data () {
		return {
			activeObject: this.title,
			user: this.$store.state.user
		}
	},

	created () {
		this.entityid = this.$route.params.entityid
		this.itemFound = false
	},

	methods: {
		clickHandler (e) {
			var target = e.currentTarget
			var objectID = target.getAttribute('data-id')
			var entityName = this.findEntityNameForID(objectID)
			this.activeObject = entityName || 'Settings'
			cms.closeActiveDropdowns()
		},

		setActiveDropDownItem () {
			if (!this.content) return
			for (var i = this.content.length - 1; i >= 0; i--) {
				var parsedID = parseInt(this.entityid)
				if (this.content[i].id === parsedID) {
					if (this.content[i].translations) {
						var entityName = this.findEntityNameForID(this.content[i].id)
						this.activeObject = entityName
						this.itemFound = true
					}
				}
			}
		},

		findEntityNameForID (id) {
			var parsedID = parseInt(id)

			for (var i = this.content.length - 1; i >= 0; i--) {
				if (this.content[i].id === parsedID) {
					return this.content[i].translations.en.value
				}
			}
		}
	},

	watch: {
		$route (to) {
			this.entityid = to.params.entityid

			if (!this.entityid) {
				this.activeObject = this.title
				if (this.dropdown) this.dropdown.classList.remove('open')
			} else {
				this.setActiveDropDownItem()
			}
		},

		content: function () {
			this.setActiveDropDownItem()
		}

	}
}
</script>
